// const baseApi = "https://guidestarindia.momsuat.com/" // Test url 

const baseApi = "https://guidestarindia.frappe.cloud" // production Url



export { baseApi }